import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import App from './App';
import './index.css';
import '@aws-amplify/ui-react/styles.css';

const REGION = import.meta.env.VITE_AWS_REGION || 'eu-west-1';
const IDENTITY_POOL_ID = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || '';

// === DEBUG MODE ===
console.log('%c🔧 KYC DEBUG MODE ENABLED', 'background: #4CAF50; color: white; padding: 10px; font-size: 16px;');
console.log('%c📍 Config:', 'color: #2196F3; font-weight: bold;', {
  region: REGION,
  identityPoolId: IDENTITY_POOL_ID,
  apiUrl: import.meta.env.VITE_API_URL,
});

// Configuración de AWS Amplify v6 para Face Liveness
Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: IDENTITY_POOL_ID,
      allowGuestAccess: true,
    },
  },
});

// Test de credenciales al cargar
(async () => {
  try {
    console.log('%c🔑 Testing Cognito credentials...', 'color: #FF9800; font-weight: bold;');
    const session = await fetchAuthSession();
    if (session.credentials) {
      console.log('%c✅ Cognito credentials OK!', 'color: #4CAF50; font-weight: bold;', {
        accessKeyId: session.credentials.accessKeyId?.substring(0, 10) + '...',
        hasSecretKey: !!session.credentials.secretAccessKey,
        hasSessionToken: !!session.credentials.sessionToken,
        expiration: session.credentials.expiration,
      });
    } else {
      console.error('%c❌ No credentials returned from Cognito', 'color: #F44336; font-weight: bold;');
    }
  } catch (error) {
    console.error('%c❌ Cognito credentials ERROR:', 'color: #F44336; font-weight: bold;', error);
  }
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

